var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("i", {
      staticClass: "icon-header__open-menu svg svg--fs_lg svg--cursor_hand",
      class: _vm.vision ? "icon-closes" : "icon-menus",
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.toggleMenu.apply(null, arguments)
        }
      }
    }),
    _c(
      "div",
      {
        staticClass: "drawer",
        class: _vm.vision ? "drawer--isactive" : "drawer--inactive"
      },
      [
        _c("div", {
          staticClass: "drawer__overlay",
          class: _vm.vision
            ? "drawer__overlay--isactive"
            : "drawer__overlay--inactive"
        }),
        _c(
          "div",
          {
            staticClass: "drawer__sidebar",
            class: _vm.vision
              ? "drawer__sidebar--isactive"
              : "drawer__sidebar--inactive"
          },
          [_vm._t("default")],
          2
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0378e9de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0378e9de","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/app/UiElements/HeaderMenuCommon.vue
// module id = 92
// module chunks = 0